import React, { memo } from 'react';
import Dropdown from '@modules/insights/insightsDropdown';
import { ORG_CHART_KEY, ORG_CHART_TITLE } from '@model';
import SectionComment from 'src/ddvComment/SectionComment';
import CommentAnchor from 'src/ddvComment/directUser/CommentAnchor';
import SectionWidget from '@components/sectionWidget/SectionWidget';
import './orgChartStyles.scss';
import { Spin, Empty } from 'antd';
import useInsightsChart, { InsightChartType } from '@hooks/useInsightsChart';
import { Loading } from '@components';

function OrgChart({ currentSubmoduleName }) {
  const { loading, saveData, data } = useInsightsChart(
    InsightChartType.OrgChart,
  );
  const handleSave = (tableData) => {
    saveData({
      id: data.id,
      moduleId: '',
      moduleType: 'insights',
      chartType: InsightChartType.OrgChart,
      data: tableData,
    });
  };

  // const fetchData = useCallback(async (projectId) => {
  //
  // }, []);

  // useEffect(() => {
  //   fetchData(projectId);
  // }, [projectId]);

  // if (loading) {
  //   return (
  //     <div className="grid-display-switch-wrapper">
  //       <Loading style={{ textAlign: 'center', marginTop: '10%' }} />
  //     </div>
  //   );
  // }

  return (
    <div className="insights-container insight-org-chart">
      <header>
        <Dropdown section={ORG_CHART_KEY} />
        <SectionComment
          module={currentSubmoduleName}
          placement="bottomRight"
          // className={`value-drivers-comment`}
        />
      </header>
      {loading ? (
        <Loading style={{ textAlign: 'center', marginTop: '10%' }} />
      ) : (
        <SectionWidget
          chartType="org"
          data={data?.data || []}
          // onDataChange={onDataChange}
          handleSave={handleSave}
          chartPlaceholder={
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No Data Available"
            />
          }
          showEmptyChart
          defaultShowGrid={false}
        />
      )}
    </div>
  );
}

export default CommentAnchor(memo(OrgChart), {
  shouldScrollInToView: (anchorRecord, anchorId) =>
    anchorRecord?.moduleName === anchorId,
  getAnchorIdFromProp(props) {
    return props.currentSubmoduleName;
  },
});
